import React, {Component} from 'react';
import {formatMoney} from '../utils/common';

export const PendingTransaction = ({value, approve, cancel}) => {
    return (
        <tr key={value.transactionId}>
            <td>
                <div className="trans-date">{value.date}</div>
            </td>
            <td>
                <div className="trans-id"><span className="d-none-sm">#</span>{value.transactionId}</div>
            </td>
            <td>
                <div className="trans-amount">{formatMoney(value.amount,0,"")}</div>
            </td>
            <td>
                <div className="trans-approve">
                    <a href="javascript:;" onClick={() => approve(value)} className="mr-4"><img src="/cashier/shop/static/assets/images/icon-accept.svg" alt=""/></a>
                    <a href="javascript:;" onClick={() => cancel(value)}><img src="/cashier/shop/static/assets/images/icon-decline.svg" alt=""/></a>
                </div>
            </td>
        </tr>
    );
}